import { AdresseModel } from "../../../../../shared/models/view/Adresse";
import { CoordinatesModel } from "../../../../../shared/models/view/Coordinates";
import { AppUtils } from '../../../../../shared/utils/index';

export class GasStationModel {

	private id: string;
	public get ID(): string {
		return this.id;
	}
	public set ID(value: string) {
		this.id = value;
	}

	private name: string;
	public get Name(): string {
		return this.name;
	}
	public set Name(value: string) {
		this.name = value;
	}

	private marke: string;
	public get Marke(): string {
		return this.marke;
	}
	public set Marke(value: string) {
		this.marke = value;
	}

	private adresse: AdresseModel;
	public get Adresse(): AdresseModel {
		return this.adresse;
	}
	public set Adresse(value: AdresseModel) {
		this.adresse = value;
	}

	private geoPosition: CoordinatesModel;
	public get GeoPosition(): CoordinatesModel {
		return this.geoPosition;
	}
	public set GeoPosition(value: CoordinatesModel) {
		this.geoPosition = value;
	}

	constructor(initialProperties?: Partial<GasStationModel>) {
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	public static createFromObject(dataObject: { [key: string]: any }): GasStationModel {
		return AppUtils.Helper.createFromMap(dataObject, GasStationModel, (key, value) => {
			switch (key) {
				case 'adresse':
				case 'Adresse':
					return AdresseModel.createFromObject(value);
				case 'geoPosition':
				case 'GeoPosition':
					return CoordinatesModel.createFromObject(value);
				default:
					return value;
			}
		});
	}

}